import { render, staticRenderFns } from "./OrdersKpi.vue?vue&type=template&id=615ab3a8&scoped=true&"
import script from "./OrdersKpi.vue?vue&type=script&lang=js&"
export * from "./OrdersKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ab3a8",
  null
  
)

export default component.exports